<!--The content below is only a placeholder and can be replaced.-->
<div id="ngCointan" class= "container animated fadeIn  text-center">
  <div id="networkStat" *ngIf="!networkStatus" class="network-disconnect"> <span class="text-center">{{networkFeedback.message}}</span>
    <span *ngIf="networkFeedback.reconnect" class="loading"></span>
  </div>
</div>
<ng-progress id="root" [color]="'#1a3d5d'"></ng-progress>
<router-outlet></router-outlet>
